"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const Header5Title = (props) => {
    const { title, theme } = props;
    if (!theme) {
        return null;
    }
    let fontType;
    let size;
    let color;
    switch (theme) {
        case "areaprivada":
            size = "title04";
            color = "white";
            fontType = "font-regular";
            break;
        case "detalle":
            size = "title04";
            color = "dark-blue";
            fontType = "font-bold";
            break;
        default:
            size = "title03";
            color = "dark-blue";
            fontType = "font-bold";
    }
    return (react_1.default.createElement("div", { className: "header5-title" },
        react_1.default.createElement("div", { className: theme },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement(next12_components_text_info_n_1.default, { text: title, fontType: fontType, size: size, color: color })))));
};
exports.default = Header5Title;
//# sourceMappingURL=index.js.map